import { render, staticRenderFns } from "./Side.vue?vue&type=template&id=59d6e105&scoped=true&"
import script from "./Side.vue?vue&type=script&lang=js&"
export * from "./Side.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d6e105",
  null
  
)

export default component.exports